import styled from '@emotion/styled';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  text-align: center;
`;

const Title = styled.h1`
  margin: 0 0 1.5rem 0;
  font-size: 2rem;
  font-weight: 600;
  color: #333;
`;

const Message = styled.p`
  margin: 0;
  font-size: 1.125rem;
  color: #666;
  max-width: 500px;
  line-height: 1.6;
`;

export const UserDisabled = () => {
  return (
    <Container>
      <Title>Account Disabled</Title>
      <Message>Your account has been disabled. Please contact support for assistance.</Message>
    </Container>
  );
};